import { c as _c } from "react/compiler-runtime";
import type React from 'react';
type FieldSectionProps = {
  title: string;
  children: React.ReactNode;
};
const FieldSection = t0 => {
  const $ = _c(7);
  const {
    title,
    children
  } = t0;
  let t1;
  if ($[0] !== title) {
    t1 = <p className="text-label-2 text-primary mb-4 fp-text">{title}</p>;
    $[0] = title;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children) {
    t2 = <div className="flex flex-col gap-3">{children}</div>;
    $[2] = children;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export default FieldSection;